import { memo, useContext, useState } from "react"
import dynamic from "next/dynamic";

import MainFormContext from "context/main-form"
import { useCallback } from "react";
import Renovation from "./renovation";

// materials
const Cabinet = dynamic(() => import("./cabinet"));
const BedsteadDesk = dynamic(() => import("./bedstead-desk"));
const ShoesBoxShelveLibrary = dynamic(() => import("./shoes-box-shelve-library"))
const OfficeshopDecoration = dynamic(() => import("./officeshop-decoration"))




const MaterialDetails = () => {

    const { values } = useContext(MainFormContext)

    const [step, setStep] = useState<number>(0)

    const backStep = useCallback(() => {
        if (step > 0) setStep(prev => --prev)
        else values.prevStep()
    }, [step])

    const forwardStep = useCallback(() => {
        setStep(prev => ++prev)
    }, [step])



    const materialStepHandler = [
        {
            label: "کابینت و کمد",
            itemName: ["CABINET", "CABINET_COMMODE"],
            component: <Cabinet back={backStep} forward={forwardStep} label="کابینت یا کابینت و کمد" />
        },
        {
            label: "تخت تاشو و میز تحریر",
            itemName: ["DESK_BED_STEAD"],
            component: <BedsteadDesk back={backStep} forward={forwardStep} label="تخت تاشو و میز تحریر" />
        },
        {
            label: "جاکفشی، قفسه و کتابخانه",
            itemName: ["SHOES_BOX_SHELVE_LIBRARY"],
            component: <ShoesBoxShelveLibrary back={backStep} forward={forwardStep} label="جاکفشی، قفسه و کتابخانه" />
        },
        {
            label: "دکور مغازه و اداری",
            itemName: ["OFFICE_OR_SHOP_DECORATION"],
            component: <OfficeshopDecoration back={backStep} forward={forwardStep} label="دکور مغازه و اداری" />
        },
        {
            label: "بازسازی",
            itemName: ["RENOVATION"],
            component: <Renovation back={backStep} forward={forwardStep} label="بازسازی" />
        },
    ]


    // handle diferent material which selected by user
    const handleMaterial = useCallback((currentStep: number): JSX.Element => {

        const materialSteps = materialStepHandler?.filter(res => values.projectItems?.find(item => res.itemName?.includes(item.itemName)))

        if (materialSteps.length > 0 && currentStep < materialSteps.length) {
            return (
                <>
                    {
                        materialSteps.map((res, index) => {
                            if (index === currentStep)
                                return <section key={index}>{res.component}</section>
                        })
                    }
                </>
            )

        } else {
            values.nextStep()
            return null;
        }

    }, [values.projectItems, step])



    return (
        <>
            {handleMaterial(step)}
        </>
    )
}

export default memo(MaterialDetails)